import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';

export type IBiService = ReturnType<typeof biService>;

/* @ngInject */
export function biService($log, wixSdk) {
  const logger = iframeAppBiLoggerFactory(window.Wix, {
    endpoint: 'music-ugc',
  })
    .updateDefaults({
      src: 9,
    })
    .logger();

  return {
    rsvp,
    sendButtonEvent,
    tickets,
  };

  function rsvp(artistName) {
    logger.log({
      evid: 210,
      artist_name: artistName,
    });
  }

  function tickets(artistName) {
    logger.log({
      evid: 211,
      artist_name: artistName,
    });
  }

  function sendButtonEvent(artistName, buttonType) {
    logger.log({
      evid: 228,
      artist_name: artistName,
      target: buttonType,
    });
  }
}
